import React, { useMemo, useState } from 'react'
import MUIDataGrid from 'common/AbstractDataGrid/DataGridMUI'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import {
  generateColumnHeader,
  SUB_HISTORY
} from 'helpers/column-generator/generateColumnHeader'
import { ICustomerSubHistoryDetails } from 'types/api/faber/subscription.type'

interface SubHistoryProps {
  getSubHistory: ICustomerSubHistoryDetails[] | undefined
  getSubHistoryLoading: boolean
  refetchSubHistory: () => void
}

export default function SubHistory({
  getSubHistory,
  getSubHistoryLoading,
  refetchSubHistory
}: SubHistoryProps) {
  /*FOR DATA GRID */
  const subHistoryColumns = generateColumnHeader(SUB_HISTORY)
  const [page, setPage] = useState(0)

  //FOR SUBSCRIPTION HISTORY
  const [subRows, setSubRows] = useState<ICustomerSubHistoryDetails[]>([])
  /*API CALL */

  //FOR FORMATTING SUBSCRIPTION HISTORY FIELDS
  useMemo(() => {
    if (getSubHistory) {
      const subHistoryData = getSubHistory.map(
        ({
          ID,
          CreatedAt,
          UpdatedAt,
          DeletedAt,
          createdBy,
          updatedBy,
          user_id,
          user_email,
          catalog_bundle_id,
          cycle_count,
          status,
          stripe_subscription_id,
          subscription_start_at,
          is_voucher_dispatched,
          paymentType,
          isPaidCurrentCycle,
          isUpgrading,
          dates,
          price,
          currency,
          planName
        }) => ({
          ID,
          CreatedAt,
          UpdatedAt,
          DeletedAt,
          createdBy,
          updatedBy,
          user_id,
          user_email,
          catalog_bundle_id,
          cycle_count,
          status,
          stripe_subscription_id,
          subscription_start_at,
          is_voucher_dispatched,
          paymentType,
          isPaidCurrentCycle,
          isUpgrading,
          dates,
          price,
          currency,
          planName
        })
      )
      setSubRows(subHistoryData)
    }
  }, [getSubHistory, refetchSubHistory])

  return (
    <MUIDataGrid
      loading={getSubHistoryLoading}
      getRowId={(row) => subRows.indexOf(row)}
      columns={subHistoryColumns}
      rows={subRows}
      tableHeight={'300px'}
      rowHeight={52}
      disableColumnFilter
      disableColumnMenu
      disableSelectionOnClick
      pagination
      page={page}
      pageSize={5}
      onPageChange={(newPage) => setPage(newPage)}
      sx={{
        '& .MuiDataGrid-iconSeparator': {
          visibility: 'hidden'
        },
        '& .MuiDataGrid-footerContainer': {
          border: '0'
        },
        '& .MuiDataGrid-cellContent': {
          fontSize: '12px',
          whiteSpace: 'normal !important',
          wordWrap: 'break-word !important'
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          fontSize: '12px',
          fontWeight: '500'
        },
        '& .MuiDataGrid-cell': {
          border: '0'
        },
        '& .MuiDataGrid-columnHeaders': {
          border: '2',
          borderWidth: '2px',
          borderColor: circlesOrbitColorPalette.neutrals[200]
        },
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
          outline: 'none'
        },
        mx: '-10px'
      }}
    />
  )
}
